import mscLogo from "@/assets/Corp_Logo-trasparent-small.webp";

export function PublicHeader() {
  return (
    <header className="bg-white border-b border-slate-200 px-6 flex items-center justify-center shrink-0">
      <img
        src={mscLogo}
        alt="Multi-Service Center Booking"
        className="max-w-[100px] "
      />
    </header>
  );
}
